import { ALLOW_EDIT } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const SupplierPriceReview: EntityType = {
  type: 'SupplierPriceReviewMutationInput',
  title: 'Supplier Price Review',
  formTitle: 'Supplier Price Review',
  formUrl: '/Suppliers/SupplierPriceReview/',
  screenReference: 'SUPPLIER_PRICE_REVIEW',
  operations: ALLOW_EDIT,
  workspaceUrl: '/menu/Suppliers', //There's no Workspace, but workspaceUrl is the default returnUrl so leveraging it for that purpose.
};

export default SupplierPriceReview;
